<elder-pane flat class="full outlined">
  <elder-pane-header>
    <elder-pane-title>
      {{ 'plannedSegments.enrichments' | translate }}
    </elder-pane-title>
    <p class="text-title-small">
      {{ 'plannedSegments.requestedAt' | translate }}
      {{ extractRequestedAt(plannedSegment()) | date: 'short' }}
    </p>

    @let error = extractError(plannedSegment());
    @if (error) {
      <div class="layout-row place-center-center" center>
        <p class="text-label-large">{{ 'plannedSegments.error' | translate }}:</p>
        <elder-popover>
          <button mat-button elderPopoverTrigger>
            {{ error | elderTruncate: 40 }}
          </button>
          <pre><code>{{ error }}</code></pre>
        </elder-popover>
      </div>
    }
  </elder-pane-header>
  <elder-pane-content>
    <elder-table class="flex" matSort [data]="enrichmentProperties()">
      <!-- icon Column -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let enrichmentProperty">
          <mat-icon> label </mat-icon>
        </td>
      </ng-container>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.id' | translate }}
        </th>
        <td mat-cell *matCellDef="let enrichmentProperty">
          {{ enrichmentProperty.propertyId }}
        </td>
      </ng-container>

      <!-- value Column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.value' | translate }}
        </th>
        <td mat-cell *matCellDef="let enrichmentProperty">
          {{ getDisplayValue(enrichmentProperty) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="enrichedAt">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'plannedSegments.enrichedAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let enrichmentProperty">
          {{ enrichmentProperty.enrichedAt | date: 'short' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="error">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'plannedSegments.error' | translate }}
        </th>
        <td mat-cell *matCellDef="let enrichmentProperty">
          @if (enrichmentProperty.error) {
            <elder-popover>
              <button mat-button elderPopoverTrigger>
                {{ enrichmentProperty.error | elderTruncate }}
              </button>
              <pre><code>{{enrichmentProperty.error  }}</code></pre>
            </elder-popover>
          }
        </td>
      </ng-container>
    </elder-table>
  </elder-pane-content>
</elder-pane>
